declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export const trackEvent = (name: string, parameters: Record<string, string | number | boolean> = {}) => {
  window.gtag?.('event', name, parameters);
};

/**
 * Sends the Google Ads contact conversion event and optionally delays navigation
 * until Google has acknowledged it (or the two-second timeout has elapsed).
 */
export const gtagSendContactEvent = (url?: string) => {
  const callback = () => {
    if (typeof url === 'string') {
      window.location.assign(url);
    }
  };

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion_event_contact', {
      event_callback: callback,
      event_timeout: 2000,
    });
  } else {
    callback();
  }

  return false;
};

export const initAnalyticsClickTracking = () => {
  document.addEventListener('click', (event) => {
    const target = event.target as Element | null;
    const anchor = target?.closest<HTMLAnchorElement>('a[href]');
    if (!anchor) return;

    const href = anchor.href;
    const path = `${anchor.pathname}${anchor.search}`;
    const linkText = anchor.textContent?.trim().replace(/\s+/g, ' ').slice(0, 80) ?? '';
    const common = { link_url: href, link_text: linkText };

    if (path.startsWith('/contact') && /reason=demo/.test(path)) {
      trackEvent('demo_request_start', common);
    } else if (/login\.clear-talent\.com\/register/.test(href)) {
      trackEvent('trial_registration_start', common);
    } else if (/apps\.apple\.com|play\.google\.com/.test(href)) {
      trackEvent('app_store_click', common);
    } else if (/partners\.clear-talent\.com/.test(href)) {
      trackEvent('partner_portal_click', common);
    } else if (path.startsWith('/showcase')) {
      trackEvent('product_tour_engagement', common);
    } else if (path.startsWith('/solutions/') || path.startsWith('/industries/')) {
      trackEvent('solution_page_engagement', common);
    }
  });
};
